



























































































import {Component, Vue} from "vue-property-decorator"
import {vxm} from "@/store"
import {Notification} from "@/interface"
import Gravatar from "@/components/Gravatar.vue"

@Component({components: {Gravatar}})
export default class NotificationView extends Vue {

  private notification: Notification | null = null

  async mounted() {
    const data = await vxm.notification.fetchNotificationById(parseInt(this.$route.params.id))
    if (data) {
      this.notification = data.notification
    }
  }

  get distribute_percentage() {
    if (this.notification) {
      return Math.floor(
        (this.notification.distribute_count || 0) / (this.notification.send_count || 0) * 1000) / 10
    } else {
      return 0
    }
  }

  get open_percentage() {
    if (this.notification) {
      return Math.floor(
        (this.notification.open_count || 0) / (this.notification.send_count || 0) * 1000) / 10
    } else {
      return 0
    }
  }

}
